import gql from 'graphql-tag'

export default gql`
  mutation AddProductToCart($input: AddProductToCartInput!) {
    addProductToCart(input: $input) {
      ... on Cart {
        id
        items {
          id
          sku
          name
          salesPrice
          quantity
          image {
            url
            description
          }
          ... on GenericCartItem {
            listPrice
            options {
              name
              value
            }
          }
        }
        marketplaceItems {
          id
          sku
          shop {
            id
            name
            retailer {
              sys {
                id
              }
              slug
            }
          }
          variant {
            quantity
            returnable
            promotions {
              campaignId
              title
            }
          }
          name
          brand
          quantity
          listPrice
          discountPrice
          image {
            url
            description
          }
          optionValues {
            id
            optionId
            displayName
            value
          }
        }
      }
      ... on InvalidInputError {
        message
        fields {
          property
          errorCode
          message
        }
      }
      ... on Error {
        message
      }
    }
  }
`
